import { MarketplaceAdResponse } from 'types/MarketplaceAdResponse';

export const getSavingsValue = (item: MarketplaceAdResponse['payload']): number | undefined =>
  item.company_valuation ? (item.company_valuation - item.price) * -1 : undefined;
